import { render, staticRenderFns } from "./IcoDot9Grid.vue?vue&type=template&id=74b451f1"
import script from "./IcoDot9Grid.vue?vue&type=script&lang=js"
export * from "./IcoDot9Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports